import React, { useId } from "react";
import PatientAutocomplete from "../PatientAutocomplete";
import ClassificationSelect from "./ClassificationSelect";
import { inputStyle, labelStyle, whiteCardStyle } from "./patientFormStyles";

const fieldsStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 2fr",
    gap: "12px",
    marginBottom: "24px",
    ...whiteCardStyle,
};

export default function PatientIdentityFields({ patient, ehpadId, nomInputRef, onFieldChange, onSelectSuggestion }) {
    const birthDateId = useId();
    const classification = (!patient.classification || patient.classification === "UNKNOWN") ? "" : patient.classification;
    return (
        <div className="commande-editor-fields" style={fieldsStyle}>
            <div>
                <label style={labelStyle}>Nom</label>
                <PatientAutocomplete
                    ehpadId={ehpadId}
                    inputRef={nomInputRef}
                    inputStyle={inputStyle}
                    placeholder="Nom"
                    value={patient.nom || ""}
                    onChange={val => onFieldChange("nom", val)}
                    onSelect={onSelectSuggestion}
                />
            </div>
            <div>
                <label style={labelStyle}>Prénom</label>
                <PatientAutocomplete
                    ehpadId={ehpadId}
                    inputStyle={inputStyle}
                    placeholder="Prénom"
                    value={patient.prenom || ""}
                    onChange={val => onFieldChange("prenom", val)}
                    onSelect={onSelectSuggestion}
                />
            </div>
            <div>
                <label htmlFor={birthDateId} style={labelStyle}>Date de naissance</label>
                <input
                    id={birthDateId}
                    style={inputStyle}
                    type="date"
                    value={patient.dateNaissance || ""}
                    onChange={e => onFieldChange("dateNaissance", e.target.value)}
                />
            </div>
            <div>
                <label style={labelStyle}>Classification</label>
                <ClassificationSelect
                    value={classification}
                    onChange={v => onFieldChange("classification", v || null)}
                />
            </div>
        </div>
    );
}
